module.exports = __webpack_public_path__ + "img/shop.eab31d43.png";